import React from "react";
import PropTypes from "prop-types";
import Tag from "../../models/Tag";
import { TAG_BG, TAG_COLOR } from "../../constants/tagConstants";
import TimesIcon from "../../../icons/Times";
import Btn from "../../../atoms/Btn";

function TagFilterPill({ tag, onRemove }) {
  const trCl = "tw-transition-all tw-duration-200";
  const cl = "tw-rounded-full tw-font-semibold tw-mb-2 tw-px-1 tw-py-0.5";
  const colorCl = TAG_COLOR[tag.tagType];
  const bgCl = `${TAG_BG[tag.tagType]} tw-bg-opacity-10`;
  const hoverCl = "tw-opacity-90 hover:tw-opacity-100";
  return (
    <div className="tw-inline-block tw-flex-shrink-0 tw-cursor-pointer">
      <div
        className={`${colorCl} ${hoverCl} ${bgCl} ${cl} ${trCl} tw-flex tw-items-center tw-gap-x-2`}
      >
        <div>
          {tag.normalized || tag.text} {tag.year ? `(${tag.year})` : ""}
        </div>

        <Btn className="tw-cursor-pointer" onSubmit={() => onRemove(tag)}>
          <TimesIcon size={10} className="tw-fill-current" />
        </Btn>
      </div>
    </div>
  );
}

TagFilterPill.propTypes = {
  onRemove: PropTypes.func.isRequired,
  tag: PropTypes.instanceOf(Tag).isRequired,
};

TagFilterPill.defaultProps = {};

export default TagFilterPill;
